import { Show, createMemo, onMount, onCleanup } from "solid-js";
import { global } from ":shared/app";
export default function FocusRoom() {
  const $settings = global.store.hooks.platform.useSettings("focus_room");
  const $link = createMemo(() => $settings().values?.url);
  let el: HTMLScriptElement = undefined;
  let ref: HTMLDivElement = undefined;

  onMount(() => {
    el = document.createElement("script");
    el.type = "text/javascript";
    el.src = "https://assets.calendly.com/assets/external/widget.js";
    el.async = true;

    if (ref == undefined) {
      document.body.append(el);
    } else {
      ref.append(el);
    }
  });
  onCleanup(() => {
    if (ref == undefined) {
      document.body.removeChild(el);
    } else {
      ref.removeChild(el);
    }
  });
  return (
    <section ref={ref} class="flex flex-row w-full h-full <md:(px-2 py-1 !rounded-xl)">
      <Show when={$link()} fallback={<div></div>}>
        <div
          class="calendly-inline-widget w-full h-full"
          data-url={$link()}
          // style="min-width:320px;height:700px;"
        ></div>
      </Show>
    </section>
  );
}
